import React from 'react';
import ConsentFormTherapist from './ConsentFormTherapist';

const ClientDataTab = ({ userId, partnerId, userName }) => {
  return (
    <div className="space-y-8">
      <ConsentFormTherapist userId={userId} partnerId={partnerId} userName={userName} />
    </div>
  );
};

export default ClientDataTab;
